import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../WebComponent'
import MonitoringKontingentDto from "./MonitoringKontingentDto";
import WeitergabeService from "../../services/WeitergabeService";
import BerechtigteListService from "../../services/BerechtigteListService";
import WeitergabeDto from "../KontingentMonitoring/WeitergabeDto";
import KontingentMonitoringWeitergabeColumns from "../KontingentMonitoring/KontingentMonitoringWeitergabeColumns";
import {List} from "@isceco/widget-library2/basic-elements/List/List";

import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '../../components/StaticDetailList/StaticDetailList'

export default class KontingentMonitoringWeitergabe extends WebComponent {
  static get properties() {
    return {
      kontingent: {type: MonitoringKontingentDto}
    }
  }

  constructor() {
    super()
    this.weitergabeService = new WeitergabeService()
    this.showCreateWeitergabeDialog = false
    this.selectedWeitergabe = null
    this.weitergabeUpdateStatus = ''
  }

  reload() {
    Promise.all([
      this.weitergabeService.getBackendListUrl(getNavigationId())
    ]).then(([weitergabeUrl]) => {
      this.weitergabeUrl = weitergabeUrl
      this.render()
    })
  }

  get translationFile() {
    return './views/KontingentMonitoring/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('kontingentMonitoring.weitergabe.title')}">
        ${this._createWeitergabeButton()}
      </isceco-title>
      <isceco-list id="weitergabe-list"
                   identifier="weitergabe"
                   url="${this.weitergabeUrl}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toWeitergabeDto}"
                   .columns="${KontingentMonitoringWeitergabeColumns.getColumns(this.i18n, this.annehmenCallback, this.ablehnenCallback, this.archivierenCallback)}"
                   .listService="${BerechtigteListService}"
      ></isceco-list>
      ${this._renderDialogWeitergabeCreate()}
      ${this._renderDialogWeitergabeUpdate()}
    `
  }

  _createWeitergabeButton() {
    return html`
      <isceco-button icon="plus" variant="primary" size="small"
                     text="${this.i18n.translate('kontingentMonitoring.weitergabe.create.button')}"
                     @click="${_ => this._toggleCreateWeitergabeDialog(true)}"
                     ?disabled="${this.kontingent.status === 'ABGESCHLOSSEN'}"
      ></isceco-button>
    `
  }

  _renderDialogWeitergabeCreate() {
    if (this.showCreateWeitergabeDialog) {
      return html`
        <isceco-dialog id="create-weitergabe-dialog"
                       header="${this.i18n.translate('kontingentMonitoring.weitergabe.create.dialog.header')}"
                       confirm-button="${this.i18n.translate('kontingentMonitoring.weitergabe.create.dialog.confirm')}"
                       cancel-button="${this.i18n.translate('kontingentMonitoring.weitergabe.create.dialog.cancel')}"
                       @submit="${event => this._handleSubmitEvent(event)}"
        >
          <isceco-form id="weitergabe-create-form">
            <div slot="form-elements" class="form-container">
              <isceco-text-input
                name="gpIdVnb"
                label="${this.i18n.translate('kontingentMonitoring.weitergabe.create.dialog.gpIdVnb')}"
                required
              ></isceco-text-input>
              <isceco-text-input
                name="kontingentierungsperiodeId"
                label="${this.i18n.translate('kontingentMonitoring.weitergabe.create.dialog.kontingentId')}"
                .value="${formatDate(this.kontingent.periodeStart)} - ${formatDate(this.kontingent.periodeEnde)}"
                disabled
              ></isceco-text-input>
              <isceco-number-input
                name="austauschmenge"
                label="${this.i18n.translate('kontingentMonitoring.weitergabe.create.dialog.austauschmenge')}"
              ></isceco-number-input>
            </div>
          </isceco-form>
        </isceco-dialog>
      `
    } else {
      return html``
    }
  }

  _renderDialogWeitergabeUpdate() {
    if (this.selectedWeitergabe !== null && this.weitergabeUpdateStatus !== '') {
      return html`
        <isceco-dialog id="update-weitergabe-dialog"
                       header="${this.i18n.translate(`kontingentMonitoring.weitergabe.update.dialog.header.${this.weitergabeUpdateStatus}`, {gpname: this.selectedWeitergabe.geschaeftspartnerName})}"
                       confirm-button="${this.i18n.translate('kontingentMonitoring.weitergabe.update.dialog.confirm')}"
                       cancel-button="${this.i18n.translate('kontingentMonitoring.weitergabe.update.dialog.cancel')}"
                       @submit="${event => this._handleUpdateEvent(event)}"
        ></isceco-dialog>
      `
    }
    return html``
  }

  _toggleCreateWeitergabeDialog(show) {
    this.showCreateWeitergabeDialog = show
    this.render()
  }

  _handleSubmitEvent(event) {
    if (!event.detail.confirmed) {
      this._toggleCreateWeitergabeDialog(false)
      return
    }
    const form = document.getElementById('weitergabe-create-form')
    if (form.validate()) {
      const obj = form.getValues()
      obj.kontingentierungsperiodeId = this.kontingent.periodeId
      this.weitergabeService.create(obj)
        .then(() => {
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'weitergabe'})
        })
        .finally(_ => {
          this._toggleCreateWeitergabeDialog(false)
          this.render()
        })
    }
  }

  _handleUpdateEvent(event) {
    if (!event.detail.confirmed) {
      this.selectedWeitergabe = null
      this.weitergabeUpdateStatus = ''
      this.render()
      return
    }

    this.weitergabeService.update({status: this.weitergabeUpdateStatus, id: this.selectedWeitergabe.id})
    .then(() => {
      send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'weitergabe'})
    })
    .finally(_ => {
      this.selectedWeitergabe = null
      this.weitergabeUpdateStatus = ''
      this.render()
    })
  }

  annehmenCallback = row => {
    this.selectedWeitergabe = row
    this.weitergabeUpdateStatus = 'ANNEHMEN'
    this.render()
  }

  ablehnenCallback = row => {
    this.selectedWeitergabe = row
    this.weitergabeUpdateStatus = 'ABLEHNEN'
    this.render()
  }

  archivierenCallback = row => {
    this.selectedWeitergabe = row
    this.weitergabeUpdateStatus = 'ARCHIVIEREN'
    this.render()
  }

  _toWeitergabeDto = row => new WeitergabeDto(row)
}

customElements.define('eko-frontend-kontingent-monitoring-weitergabe', KontingentMonitoringWeitergabe)
